<template>
    <div>
        <div class="card card-info">
            <div class="card-header with-border">
                <h3 class="card-title">My Applications</h3>
            </div>
            <div class="card-body p-0">
                <div class="table-responsive" style="padding-bottom: 20px;">
                    <table class="table m-0">
                        <thead>
                            <tr>
                                <th>Job Title</th>
                                <th>Application No</th>
                                <th>Applicant Name</th>
                                <th>Application Date</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="item in lst">
                                <td>
                                    {{item.JobTitle}}
                                    <span v-if="item.ApplicationStatus == 'Submitted'" class="badge badge-success">Submitted</span>
                                    <span v-else class="badge badge-danger">Pending</span>
                                </td>
                                <td> {{item.ApplicationNo}}  </td>
                                <td> {{item.Name}}  </td>
                                <td> {{item.AppliedOn}}  </td>
                                <td style="white-space: nowrap">
                                    <button v-if="item.ApplicationStatus != 'Submitted'" class="btn btn-primary btn-sm" v-on:click="editApplication(item.ApplicantRegistrationID)">Edit</button>
                                    <button v-if="item.ApplicationStatus != 'Submitted'" class="btn btn-success btn-sm" v-on:click="callmodel(item.ApplicantRegistrationID)">Submit</button>
                                    <button v-if="item.ApplicationStatus != 'Submitted'" class="btn btn-warning btn-sm" v-on:click="printCV(item.ApplicantRegistrationID)">Draft Print </button>
                                    <button v-if="item.ApplicationStatus == 'Submitted'" class="btn btn-warning btn-sm" v-on:click="printCV(item.ApplicantRegistrationID)">Print </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div class="modal fade" id="mdlPatientRecord">
            <div class="modal-dialog ">
                <div class="modal-content">
                    <div class="modal-header bg-primary">
                        <h4 class="modal-title">Alert!</h4>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-md-12">
                                <h6>Are you sure you want to submit your application?</h6>
                            </div>

                        </div>
                    </div>
                    <div class="modal-footer ">
                        <button type="button" class="btn btn-default" data-dismiss="modal">
                            Close
                        </button>
                        <button type="button" class="btn btn-success" v-on:click="submitApplication()">
                            Submit
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade" id="mdlError">
            <div class="modal-dialog ">
                <div class="modal-content">
                    <div class="modal-header bg-danger">
                        <h4 class="modal-title">Incomplete Data!</h4>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-md-12">
                                <ul>
                                    <li v-for="item in errorList">{{item}}</li>
                                </ul>

                                <p>Please make sure you have uploaded all documents</p>
                            </div>

                        </div>
                    </div>
                    <div class="modal-footer ">
                        <button type="button" class="btn btn-default" data-dismiss="modal">
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>const axios = require('axios').default;

    export default ({
        data() {
            return {
                lst: [],
                ApplicantRegistrationID: 0,
                errorList: []
            }
        },
        created: function () {
            this.pageLoad();
        },
        updated: function () {
        },
        methods:
        {
            pageLoad() {
                startReq();
                var vm = this;
                axios.post('/ApplicantsApi/loadApplications')
                    .then(function (response) {
                        if (response.data.status) {
                            endReq();
                            vm.lst = response.data.lst;
                        }
                        else {
                            endReq();
                        }
                    })
            },
            editApplication(id) {
                window.location.href = "../Jobs/ApplyForJob?id=" + id;
            },
            callmodel(id) {
                this.ApplicantRegistrationID = id;
                $('#mdlPatientRecord').modal('show');
            },
            submitApplication() {
                var vm = this;
                startReq();
                axios.post("/ApplicantsApi/SubmitJobApplication?ID=" + vm.ApplicantRegistrationID)
                    .then(function (res) { 
                        if (res.data.status) { 
                            setTimeout(function () { window.location.reload() }, 1000);
                        }
                        else {
                            endReq();
                            toastr.error(res.data.msg);
                            vm.errorList = res.data.lst;
                            $('#mdlPatientRecord').modal('hide');
                            $('#mdlError').modal('show');
                        }
                    })
                    .catch(function (error) {

                    });

            },
            printCV(id) {
                var vm = this;
                startReq();
                axios.post('/ApplicantsApi/printCVForm?ID=' + id)
                    .then(function (res) {
                        endReq();
                        window.open(res.data.url, '_blank');
                        //redirect_blank(res.data.url);
                    })
                    .catch(function (error) {
                        console.log(error);
                    })
            },

        }
    });</script>



// WEBPACK FOOTER //
// src/components/applicantDashboard.vue